import React from 'react';
import Icon from '../../../components/AppIcon';
import { useNavigate } from 'react-router-dom';

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <div className="relative overflow-hidden">
      {/* Animated background blobs */}
      <div className="absolute -top-20 -left-20 w-96 h-96 bg-cyan-400/20 rounded-full blur-3xl animate-pulse" />
      <div className="absolute top-10 right-0 w-80 h-80 bg-violet-400/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }} />
      <div className="absolute bottom-0 left-1/3 w-72 h-72 bg-amber-400/15 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '2s' }} />
      {/* Badge */}
      <div className="relative z-10 mb-6">
        <div className="inline-flex items-center gap-2 bg-gradient-to-r from-cyan-500/10 to-violet-500/10 border border-cyan-300/40 px-4 py-2 rounded-full">
          <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
          <span className="text-sm font-medium text-cyan-700">StudyExpo — Now Live</span>
        </div>
      </div>
      {/* Main Headline */}
      <div className="relative z-10 mb-6">
        <h1 className="text-4xl md:text-6xl font-heading font-bold text-foreground leading-tight mb-4">
          Find Your Perfect{' '}
          <span className="relative">
            <span className="bg-gradient-to-r from-cyan-600 via-violet-600 to-amber-500 bg-clip-text text-transparent">
              Institution
            </span>
            <svg className="absolute -bottom-2 left-0 w-full" height="6" viewBox="0 0 200 6" fill="none">
              <path d="M0 3 Q50 0 100 3 Q150 6 200 3" stroke="url(#underline-grad)" strokeWidth="2.5" fill="none" strokeLinecap="round"/>
              <defs>
                <linearGradient id="underline-grad" x1="0" y1="0" x2="200" y2="0" gradientUnits="userSpaceOnUse">
                  <stop stopColor="#0891B2"/>
                  <stop offset="0.5" stopColor="#8B5CF6"/>
                  <stop offset="1" stopColor="#F59E0B"/>
                </linearGradient>
              </defs>
            </svg>
          </span>
        </h1>
        <p className="text-lg md:text-xl text-muted-foreground max-w-2xl leading-relaxed">
          Connect with top colleges and universities. Explore courses, attend live webinars, take virtual campus tours — all from your screen.
        </p>
      </div>
      {/* CTA Buttons */}
      <div className="relative z-10 flex flex-wrap gap-4 mb-10">
        <button
          onClick={() => navigate('/student-registration')}
          className="group flex items-center gap-3 bg-gradient-to-r from-cyan-600 to-violet-600 text-white px-7 py-4 rounded-xl font-semibold text-base shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all duration-200"
        >
          <Icon name="UserPlus" size={20} color="white" />
          Register as Student — Free
          <Icon name="ArrowRight" size={18} color="white" className="group-hover:translate-x-1 transition-transform" />
        </button>
        <button
          onClick={() => navigate('/institute-login')}
          className="group flex items-center gap-3 bg-white border-2 border-violet-200 text-violet-700 px-7 py-4 rounded-xl font-semibold text-base shadow-md hover:shadow-lg hover:-translate-y-0.5 hover:border-violet-400 transition-all duration-200"
        >
          <Icon name="Building2" size={20} color="currentColor" />
          Institute Login
        </button>
      </div>
      {/* Student Image */}
      <div className="relative z-10">
        <div className="relative rounded-2xl overflow-hidden shadow-xl border border-white/60 bg-gradient-to-br from-cyan-50 to-violet-50">
          <img
            src="/assets/images/student_researching_institutes.png"
            alt="Student browsing and researching colleges and universities on a laptop, exploring higher education options"
            className="w-full h-80 md:h-[480px] lg:h-[560px] object-cover object-top"
          />
          {/* Overlay caption */}
          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/50 to-transparent px-5 py-4">
            <p className="text-white text-sm font-medium flex items-center gap-2">
              <Icon name="Search" size={15} color="white" />
              Explore 100s of institutions — all in one place
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;